module.exports = __webpack_public_path__ + "s8.no1.dfaa633d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/s8.no1.jpg
// module id = Umff
// module chunks = 0